import type { HeatmapQuery } from '@/schemas/heatmap'

/**
 * Query key factory.
 *
 * One key covering both depths, because the drill-in is the same map at a
 * different scope: `{ sizing: 'cap' }` and `{ sector: 'banking', sizing:
 * 'cap' }` are two entries under one parent, so going back up the breadcrumb
 * paints from cache instead of refetching a map the member just looked at.
 *
 * `sizing` rides in the key because it rides in the request: mm-be sizes the
 * tiles itself, so each chip is a different response.
 */
export const heatmapKeys = {
  all: ['heatmap'] as const,
  maps: () => [...heatmapKeys.all, 'map'] as const,
  map: (query: HeatmapQuery) => [...heatmapKeys.maps(), query] as const,
}
